import {combineReducers} from 'redux'
import types from 'actions/types'

const loading = (state = false, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_SUCCESS:
      return false

    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_FAILURE:
      return false

    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_ATTEMPT:
      return true

    default: return state
  }
}

const printTemplate = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_SUCCESS:
      return action.printTemplate

    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_ATTEMPT:
      return null

    default: return state
  }
}

const saving = (state = false, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_SUCCESS:
      return false

    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_FAILURE:
      return false

    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_ATTEMPT:
      return true

    default: return state
  }
}

const error = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_SUCCESS:
      return null

    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_FAILURE:
      return action.message

    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_ATTEMPT:
      return null

    default: return state
  }
}

const order = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_ORDER:
      return action.order
    default:
      return state
  }
}

const purchaseOrder = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_PURCHASE_ORDER:
      return action.purchaseOrder
    default:
      return state
  }
}

const deliveryNote = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_DELIVERY_NOTE:
      return action.deliveryNote
    default:
      return state
  }
}

const invoice = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_UPDATE_INVOICE:
      return action.invoice
    default:
      return state
  }
}

const selectedQuotePrintTemplateGroupId = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_QUOTE_SELECT_PRINT_TEMPLATE_GROUP_ID:
      return action.printTemplateGroupId
    default:
      return state
  }
}

const selectedPurchasePrintTemplateGroupId = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_PURCHASE_SELECT_PRINT_TEMPLATE_GROUP_ID:
      return action.printTemplateGroupId
    default:
      return state
  }
}

const selectedDeliveryPrintTemplateGroupId = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_DELIVERIES_SELECT_PRINT_TEMPLATE_GROUP_ID:
      return action.printTemplateGroupId
    default:
      return state
  }
}

const selectedInvoicesPrintTemplateGroupId = (state = null, action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_INVOICE_SELECT_PRINT_TEMPLATE_GROUP_ID:
      return action.printTemplateGroupId
    default:
      return state
  }
}

export default combineReducers({
  printTemplate,
  loading,
  saving,
  error,
  order,
  purchaseOrder,
  deliveryNote,
  invoice,
  selectedQuotePrintTemplateGroupId,
  selectedPurchasePrintTemplateGroupId,
  selectedDeliveryPrintTemplateGroupId,
  selectedInvoicesPrintTemplateGroupId,
})
